export default __webpack_public_path__ + "static/media/project_creation_thumbnail_2.718d9b0c.PNG";